import { InstructionFormService } from '../form-service/instruction-form.service';
export class FilterFormService extends InstructionFormService {}